type BookmarkNotesProps = {
  notes: string | null | undefined
  userFullName: string
}

export const BookmarkNotes: React.FC<BookmarkNotesProps> = ({ notes, userFullName }) => {
  if (!notes) return null

  return (
    <blockquote className="mt-2 border-l border-gray-99 pl-4">
      <p className="text-sm text-gray-99">
        “{notes}”{" "}
        <span className="ml-2 break-keep">
          <span className="me-1">–</span>
          {userFullName}
        </span>
      </p>
    </blockquote>
  )
}
